<template>
  <div class="Alert__container">

    <AppAlert v-for="alert in alerts" :title="alert.title" :text="alert.text" :key="alert.id" :id="alert.id" >
      <div v-html="alert.text"></div>
    </AppAlert>

    <AppAlert
        v-for="(notification, index) in notifications"
        :key="index"
        :id="'servernotification'+index"
        :preventClose="true"
        :link="notification.link"
    >
      <div>
        <p>{{ notification.text }}</p>
      </div>
    </AppAlert>

    <AppAlert v-if="$page.props.errors.global_error" :title="$page.props.errors.global_error" text="" :key="$page.props.errors.navigate_on" :id="$page.props.errors.navigate_on" />
    
  </div>
</template>

<script>
  import { useAlerts } from '@/store/alerts'
  import AppAlert from "@components/app/AppAlert";

  export default {
    components : { AppAlert },
    computed: {
      notifications(){
        return (this.$page.props.notifications ?? []).filter((notif) => notif.type === 'infobulle')
      }
    },
    setup() {
      return {
        alerts : useAlerts.get()
      }
    }
  }
</script>
